import dayjs from "dayjs";

// Bakker "packing code" legend:
// - Month code: January -> A ... December -> L
// - Day code: 1 -> A1 ... 26 -> Z1, 27 -> A2 ... 31 -> E2
export const BAKKER_PACKING_CODE_LEGEND = {
    months: {
        1: "A",
        2: "B",
        3: "C",
        4: "D",
        5: "E",
        6: "F",
        7: "G",
        8: "H",
        9: "I",
        10: "J",
        11: "K",
        12: "L",
    },
    days: {
        1: "A1",
        2: "B1",
        3: "C1",
        4: "D1",
        5: "E1",
        6: "F1",
        7: "G1",
        8: "H1",
        9: "I1",
        10: "J1",
        11: "K1",
        12: "L1",
        13: "M1",
        14: "N1",
        15: "O1",
        16: "P1",
        17: "Q1",
        18: "R1",
        19: "S1",
        20: "T1",
        21: "U1",
        22: "V1",
        23: "W1",
        24: "X1",
        25: "Y1",
        26: "Z1",
        27: "A2",
        28: "B2",
        29: "C2",
        30: "D2",
        31: "E2",
    },
} as const;

export function packingDate2BakkerPackingCode(packingDate?: string | null): string | undefined {
    if (!packingDate) return undefined;

    const d = dayjs(packingDate);
    if (!d.isValid()) return undefined;

    const month = d.month() + 1; // dayjs months are 0-based
    const day = d.date();

    const monthCode = BAKKER_PACKING_CODE_LEGEND.months[month as keyof typeof BAKKER_PACKING_CODE_LEGEND.months];
    const dayCode = BAKKER_PACKING_CODE_LEGEND.days[day as keyof typeof BAKKER_PACKING_CODE_LEGEND.days];

    if (!monthCode || !dayCode) return undefined;
    return `${monthCode}${dayCode}`;
}
